export const whistleblowerKeys = {
  all: ["/whistleblower"] as const,
  details: () => [...whistleblowerKeys.all, "detail"] as const,
  detail: (id: string) => [...whistleblowerKeys.details(), id] as const,
};
